import PropTypes from 'prop-types';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export function BarPercentageChart({ chartData, title, showTitle = true }) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: showTitle,
        text: `${title}`,
      },
    },
    scales: {
      y: {
        ticks: {
          format: {
            style: 'percent',
          },
        },
        display: true,
      },
    },
    maintainAspectRatio: false,
  };

  return <Bar options={options} data={chartData} />;
}

BarPercentageChart.propTypes = {
  chartData: PropTypes.object,
  title: PropTypes.string,
  showTitle: PropTypes.bool,
};
